<template>
	<div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0">
		<Navigator :fixed="false"/>
		<div class="bg">
			<el-image :src="fg" fit="cover" />
			
			<div class="nav nav-cont">
				<span class="sub-title">
					Reunion ceremony
				</span>
				<span class="title">
					—— 喜上加喜团聚礼 开年人品大爆发 ——
				</span>
			</div>
			
			<div class="bg2">
				<div class="container">
					<el-image v-for="(item,index) in ads" :src="item" :key="index" fit="cover" style="margin-top: 40px;margin-bottom: 40px;" />
					
				</div>
			</div>
		</div>
		
		

		<Contact />
		<Footer />
	</div>
</template>

<script>
	import Navigator from '../index/widgets/navigator.vue'
	import Contact from "../index/widgets/Contact.vue"
	import Footer from '../index/widgets/footer.vue'

	export default {
		components: {
			Navigator,
			Contact,
			Footer,
		},
		data() {
			return {
				isFixed: false,
				fg: require('@/assets/images/recommend/fg.png'),
				ads: [
					require('@/assets/images/recommend/1.png'),
					require('@/assets/images/recommend/2.png'),
					require('@/assets/images/recommend/3.png')
				],
			}
		},
		methods: {
		},
	}
</script>


<style scoped lang="scss">
.bg {
	background-image: url(../../assets/images/recommend/bg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
}

.bg2 {
	background-image: url(../../assets/images/recommend/bg2.png);
	background-size: 100% auto;
	background-repeat: no-repeat;
}

.nav {
	background-image: url(../../assets/images/recommend/nav.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	padding-top: 2vw;
	padding-bottom: 3vw;
	
	display: flex;
	flex-direction: column;
	align-items: center;
		
	.sub-title {
		font-size: calc(1em + 0.5vw);
		font-family: SourceHanSansCN-Normal, SourceHanSansCN;
		font-weight: 400;
		color: #954A00;
		line-height: 29px;
		letter-spacing: 7px;
	}
	
	.title {
		font-size: calc(1em + 1.5vw);
		font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
		font-weight: bold;
		color: #E7432F;
		}

}
</style>